import type {ConsentStatus, UserResponse} from '@/ts/types/dto/user-dto';

/** Approved at the current version; a missing record counts as not given, as the backend treats it. */
function isGiven(consent: ConsentStatus | null | undefined): boolean {
  return consent?.approved === true && !consent.needsReapproval;
}

/**
 * Whether the backend's legal consent gate is closed for this user.
 *
 * Mirrors `TermsAndConditionsConsentValidationFilter` and `PrivacyPolicyValidationFilter` in the
 * backend: every authenticated endpoint other than the exact `/me` path and the consent endpoints
 * answers `CONSENT_REQUIRED` or `CONSENT_NEEDS_REAPPROVAL` until both documents are approved at their
 * current version. While this holds, nothing else the app offers can work, renewal and the
 * Instructions for Use acknowledgement included, so the consent flow comes before every other prompt.
 *
 * Unknown is not pending: no user data yet (before `/me` resolves), or a user payload without its
 * consents, gates nothing.
 */
export function isLegalConsentPending(userData: Pick<UserResponse, 'consents'> | null | undefined): boolean {
  if (!userData?.consents) {
    return false;
  }
  return !isGiven(userData.consents.termsAndConditions) || !isGiven(userData.consents.privacyPolicy);
}
